/* Kiyohako — theme.js */

(function () {
  "use strict";

  var PRODUCTS = window.PRODUCTS || [];
  var FAQ = window.FAQ || [];
  /* Halloween offer (Shopify automatic discount, −40 € on the One until 2 Nov 2026): Shopify does not stack it
     with the free mat code, so the code offers (TAPISOFFERT) are off until it ends */
  var OFFER_END = Date.parse("2026-11-02T23:59:59+01:00");
  var BUNDLES = (window.BUNDLES || []).filter(function (b) { return !(b.code && Date.now() <= OFFER_END); });

  /* Shopify: window.KH_SHOP is written by layout/theme.liquid (prices, variants, cart, routes).
     Without it (static preview) the theme runs on products.js alone, with a local cart. */
  var SHOP = window.KH_SHOP || null;

  function asset(src) {
    var m = SHOP && typeof src === "string" && /^assets\/(?:images|video|brand)\/(.+)$/.exec(src);
    if (!m) return src;
    if (SHOP.fileUrls && SHOP.fileUrls[m[1]]) return SHOP.fileUrls[m[1]];
    return ((SHOP.fileAssets || []).indexOf(m[1]) >= 0 ? SHOP.files : SHOP.assets) + m[1];
  }

  function link(href) {
    if (!SHOP) return href;
    var m = /^([\w-]+)\.html(.*)$/.exec(href);
    return m && SHOP.links[m[1]] != null ? SHOP.links[m[1]] + m[2] : href;
  }

  if (SHOP) {
    (function rewrite(o) {
      Object.keys(o).forEach(function (k) {
        if (typeof o[k] === "string") o[k] = asset(o[k]);
        else if (o[k] && typeof o[k] === "object") rewrite(o[k]);
      });
    })(PRODUCTS);
    PRODUCTS = PRODUCTS.filter(function (p) {
      var s = SHOP.products[p.handle];
      if (!s) return false;
      p.price = s.price;
      p.compareAt = s.compareAt > s.price ? s.compareAt : null;
      p.variantId = s.variant;
      p.available = s.available;
      /* Reviews come from Shopify's review metafields, which Judge.me fills */
      p.rating = s.rating ? Math.round(Number(s.rating) * 10) / 10 : null;
      p.reviews = s.reviews || null;
      if (p.colors) {
        p.colors = p.colors.filter(function (c) { return (s.variants || []).some(function (v) { return v.name === c.name; }); });
        if (p.colors.length < 2) delete p.colors;
      }
      return true;
    });
  }

  function bundleFor(main, item) {
    for (var i = 0; i < BUNDLES.length; i++) if (BUNDLES[i].main === main && BUNDLES[i].item === item) return BUNDLES[i];
    return null;
  }

  /* A welcome gift (pack with a code) only becomes free at checkout: its cart line says how */
  function giftNote(handle, lines) {
    for (var i = 0; i < BUNDLES.length; i++) {
      var b = BUNDLES[i];
      if (b.code && b.item === handle && lines.some(function (l) { return l.handle === b.main; })) return "Offert au paiement : code " + b.code + " appliqué (1re commande)";
    }
    return "";
  }

  /* The gift's code, when both products are in the cart: checkout opens with it (Shopify still checks the first order) */
  function cartCode(lines) {
    function has(h) { return lines.some(function (l) { return l.handle === h; }); }
    for (var i = 0; i < BUNDLES.length; i++) if (BUNDLES[i].code && has(BUNDLES[i].main) && has(BUNDLES[i].item)) return BUNDLES[i].code;
    return "";
  }

  /* Like Shopify: a pack discount needs its own unit of the main product (one product discount per item),
     so a Kiyohako One unlocks one pack only, the best value first. A welcome code only applies at checkout. */
  function cartDiscounts(lines) {
    var qty = {};
    lines.forEach(function (l) { qty[l.handle] = (qty[l.handle] || 0) + l.qty; });
    return BUNDLES.filter(function (b) { return !b.code; }).sort(function (a, b) { return b.discount - a.discount; }).map(function (b) {
      var n = Math.min(qty[b.main] || 0, qty[b.item] || 0);
      qty[b.main] = (qty[b.main] || 0) - n;
      return n ? { label: b.label, amount: b.discount * n } : null;
    }).filter(Boolean);
  }
  var CART_KEY = "kiyohako-cart";
  var INSTALLMENT_MIN = 10000;
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Helpers ------------------------------------------------------- */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function money(cents) {
    var digits = cents % 100 === 0 ? 0 : 2;
    return new Intl.NumberFormat("fr-FR", {
      style: "currency", currency: "EUR", minimumFractionDigits: digits, maximumFractionDigits: digits
    }).format(cents / 100);
  }

  function installment(cents, n) {
    return money(Math.ceil(cents / n / 100) * 100);
  }

  /* Estimated delivery: shipped within 2 working days, delivered 3 to 7 working days after the order */
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
      f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
      i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, month - 1, day);
  }

  function isWorkingDay(d) {
    if (d.getDay() === 0 || d.getDay() === 6) return false;
    var md = (d.getMonth() + 1) + "-" + d.getDate();
    if (["1-1", "5-1", "5-8", "7-14", "8-15", "11-1", "11-11", "12-25"].indexOf(md) > -1) return false;
    var e = easter(d.getFullYear());
    return [1, 39, 50].every(function (n) {
      var h = new Date(e.getFullYear(), e.getMonth(), e.getDate() + n);
      return h.toDateString() !== d.toDateString();
    });
  }

  function addWorkingDays(from, n) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    while (n > 0) { d.setDate(d.getDate() + 1); if (isWorkingDay(d)) n--; }
    return d;
  }

  var DEFAULT_DELIVERY = [3, 7];

  function deliveryRange(list) {
    var ranges = list.map(function (p) { return (p && p.delivery) || DEFAULT_DELIVERY; });
    if (!ranges.length) return DEFAULT_DELIVERY;
    return [Math.max.apply(null, ranges.map(function (r) { return r[0]; })), Math.max.apply(null, ranges.map(function (r) { return r[1]; }))];
  }

  function deliveryWindow(short, range) {
    range = range || DEFAULT_DELIVERY;
    var now = new Date();
    var a = addWorkingDays(now, range[0]), b = addWorkingDays(now, range[1]);
    var w = short ? "short" : "long";
    var day = { weekday: w, day: "numeric" };
    var full = { weekday: w, day: "numeric", month: w };
    var start = a.toLocaleDateString("fr-FR", a.getMonth() === b.getMonth() ? day : full);
    return "entre le " + start + " et le " + b.toLocaleDateString("fr-FR", full);
  }

  function find(handle) {
    for (var i = 0; i < PRODUCTS.length; i++) if (PRODUCTS[i].handle === handle) return PRODUCTS[i];
    return null;
  }

  /* Colours: p.colors lists the variants that change photos and SKU. The first one is the product as described. */
  var chosen = {};

  function colorOf(p, name) {
    var list = (p && p.colors) || [];
    for (var i = 0; i < list.length; i++) if (list[i].name === name) return list[i];
    return null;
  }

  function inColor(p, name) {
    var c = colorOf(p, name);
    if (!c || c === p.colors[0]) return p;
    var v = Object.create(p);
    ["images", "cardImages", "merchantImages", "sku"].forEach(function (k) { if (c[k]) v[k] = c[k]; });
    v.color = c.name;
    return v;
  }

  function chosenColor(p) { return (p.colors && chosen[p.handle]) || p.color; }

  function shopVariant(p, color) {
    var s = SHOP && SHOP.products[p.handle];
    var v = s && (s.variants || []).filter(function (x) { return x.name === color; })[0];
    return v || { id: p.variantId, available: p.available };
  }

  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function productUrl(p) { return SHOP ? "/products/" + encodeURIComponent(p.handle) : encodeURIComponent(p.handle) + ".html"; }

  var ICON_CHECK =
    '<svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true"><rect width="20" height="20" rx="5" fill="currentColor"/>' +
    '<path d="M5.5 10.2l3 3 6-6.4" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_TICK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
    var ICON_TRUCK = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>';
    var ICON_SOUND_OFF = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 10v4h3l5 4V6L7 10z"/><path d="M16 9.5l5 5M21 9.5l-5 5"/></svg>';
  var ICON_SOUND_ON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 10v4h3l5 4V6L7 10z"/><path d="M16 9a4 4 0 0 1 0 6M18.5 6.5a7.5 7.5 0 0 1 0 11"/></svg>';
  var ICON_PLUS =
    '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M7 1v12M1 7h12" stroke="currentColor" stroke-width="1.6"/></svg>';

  function checks(list) {
    return list.map(function (t) {
      var k = t.indexOf(" : "); // « Bénéfice : preuve » : le bénéfice passe en gras
      var text = k > 0 ? "<strong>" + esc(t.slice(0, k)) + "</strong>" + esc(t.slice(k)) : esc(t);
      return "<li>" + ICON_CHECK + "<span>" + text + "</span></li>";
    }).join("");
  }

  /* Cart ---------------------------------------------------------- */

  var memoryCart = [];
  var shopCart = SHOP ? SHOP.cart : null;

  function readCart() {
    if (SHOP) {
      return ((shopCart && shopCart.items) || []).map(function (it) {
        var base = find(it.handle);
        return {
          handle: it.handle, qty: it.quantity, key: it.key, line: it.original_line_price, color: it.variant_title,
          p: base ? inColor(base, it.variant_title) : { handle: it.handle, title: it.product_title, subtitle: it.variant_title || "", price: it.price, images: [{ src: it.image || "", alt: "" }] }
        };
      });
    }
    try {
      var raw = window.localStorage.getItem(CART_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.filter(function (l) { return find(l.handle); }) : [];
    } catch (e) {
      return memoryCart;
    }
  }

  function writeCart(lines) {
    memoryCart = lines;
    try { window.localStorage.setItem(CART_KEY, JSON.stringify(lines)); } catch (e) {}
    renderCart();
  }

  function lineProduct(l) { return l.p || inColor(find(l.handle), l.color); }

  function lineKey(l) { return l.key || l.handle + "|" + (l.color || ""); }

  function shopRequest(url, body) {
    if (drawer) drawer.classList.add("is-busy");
    var json = { "Content-Type": "application/json", Accept: "application/json" };
    return fetch(url, { method: "POST", headers: json, body: JSON.stringify(body), credentials: "same-origin" })
      .catch(function () {})
      .then(function () { return fetch(SHOP.routes.cart + ".js", { headers: json, credentials: "same-origin" }); })
      .then(function (r) { return r.json(); })
      .then(function (c) { shopCart = c; renderCart(); })
      .catch(function () {})
      .then(function () { if (drawer) drawer.classList.remove("is-busy"); });
  }

  function addToCart(handles) {
    if (SHOP) {
      var qty = {};
      handles.forEach(function (h) {
        var p = find(h), id = p && shopVariant(p, chosenColor(p)).id;
        if (id) qty[id] = (qty[id] || 0) + 1;
      });
      var items = Object.keys(qty).map(function (id) { return { id: Number(id), quantity: qty[id] }; });
      if (items.length) shopRequest(SHOP.routes.cartAdd + ".js", { items: items });
      return;
    }
    var lines = readCart();
    handles.forEach(function (handle) {
      var p = find(handle), color = p && p.colors ? chosenColor(p) : undefined;
      var line = lines.filter(function (l) { return l.handle === handle && l.color === color; })[0];
      if (line) line.qty += 1;
      else lines.push({ handle: handle, qty: 1, color: color });
    });
    writeCart(lines);
  }

  function setQty(key, qty) {
    if (SHOP) {
      shopRequest(SHOP.routes.cartChange + ".js", { id: key, quantity: Math.max(0, qty) });
      return;
    }
    var lines = readCart()
      .map(function (l) { if (lineKey(l) === key) l.qty = qty; return l; })
      .filter(function (l) { return l.qty > 0; });
    writeCart(lines);
  }

  function shopDiscounts() {
    if (!shopCart || !shopCart.total_discount) return [];
    var titles = (shopCart.cart_level_discount_applications || []).map(function (d) { return d.title; });
    shopCart.items.forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        if (titles.indexOf(a.discount_application.title) < 0) titles.push(a.discount_application.title);
      });
    });
    /* Both packs (Duo and tapis) can apply together: one line for the total */
    var label = titles.length > 1 ? (titles.every(function (t) { return /^Remise pack/.test(t); }) ? "Remises packs" : "Remises") : titles[0];
    return [{ label: label || "Remise", amount: shopCart.total_discount }];
  }

  function cartCount(lines) {
    return lines.reduce(function (n, l) { return n + l.qty; }, 0);
  }

  /* Drawer -------------------------------------------------------- */

  function buildDrawer() {
    var el = document.createElement("div");
    el.className = "drawer";
    el.id = "cart-drawer";
    el.setAttribute("aria-hidden", "true");
    el.innerHTML =
      '<div class="drawer-scrim" data-cart-close></div>' +
      '<aside class="drawer-panel" role="dialog" aria-modal="true" aria-labelledby="cart-title">' +
        '<div class="drawer-head"><h2 id="cart-title" class="drawer-title">Votre panier <span class="drawer-count tnum" data-cart-n>0</span></h2>' +
        '<button type="button" class="drawer-x" data-cart-close aria-label="Fermer le panier">' + ICON_X + "</button></div>" +
        '<div class="drawer-scroll">' +
          '<p class="drawer-ship" data-cart-ship hidden></p>' +
          '<div class="drawer-foot" data-cart-foot>' +
            '<div class="drawer-total tnum"><span>Mon total</span><span data-cart-total></span></div>' +
            '<dl class="drawer-rows tnum"><div><dt>Sous-total</dt><dd data-cart-subtotal></dd></div><div data-cart-discount hidden><dt></dt><dd></dd></div><div><dt>Livraison</dt><dd>Offerte</dd></div></dl>' +
            '<button type="button" class="btn btn--block drawer-checkout" data-checkout>Passer commande</button>' +
            '<p class="drawer-install tnum" data-cart-install></p>' +
            '<div class="express"><p>ou payez avec</p>' +
              '<div class="express-btns"><button type="button" data-checkout-express>Apple&nbsp;Pay</button></div>' +
            "</div>" +
            '<p class="drawer-guest small muted">Paiement sécurisé par carte (CB, Visa, Mastercard, Amex), Apple&nbsp;Pay ou Klarna. Sans création de compte.</p>' +
          "</div>" +
          '<div class="drawer-items" data-cart-items></div>' +
        "</div>" +
      "</aside>";
    document.body.appendChild(el);
    if (SHOP) {
      var express = $("#kh-express"), btns = $(".express-btns", el), label = $(".express p", el);
      if (express && express.children.length) {
        btns.innerHTML = ""; while (express.firstChild) btns.appendChild(express.firstChild);
        // "ou payez avec" only once a wallet button (Apple Pay, Google Pay…) is really drawn: Shopify renders nothing when none is available
        label.hidden = true;
        if (window.ResizeObserver) new ResizeObserver(function () { label.hidden = btns.offsetHeight < 24; }).observe(btns);
      }
      else $(".express", el).hidden = true;
    }
    return el;
  }

  var drawer;
  var lastFocus;

  function openCart() {
    closeMenu();
    closeSheets();
    lastFocus = document.activeElement;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("is-locked");
    var close = $(".drawer-x", drawer);
    if (close) setTimeout(function () { close.focus(); }, 50);
  }

  function closeCart() {
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("is-locked");
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function renderCart() {
    var lines = readCart();
    var count = cartCount(lines);

    $$("[data-cart-count]").forEach(function (n) { n.textContent = count; n.hidden = count === 0; });
    if (!drawer) return;

    $("[data-cart-n]", drawer).textContent = count;
    var ship = $("[data-cart-ship]", drawer);
    ship.hidden = !lines.length;
    var narrow = window.matchMedia("(max-width: 600px)").matches;
    ship.innerHTML = ICON_TRUCK + "<span>" + (narrow ? "Reçue " : "Livraison offerte, reçue ") + "<strong>" + deliveryWindow(narrow, deliveryRange(lines.map(lineProduct))) + "</strong></span>";

    var items = $("[data-cart-items]", drawer);
    var foot = $("[data-cart-foot]", drawer);

    if (!lines.length) {
      items.innerHTML =
        '<div class="drawer-empty"><p>Votre panier est vide.</p>' +
        '<a class="link" href="' + link("collection.html") + '">Continuer mes achats</a></div>';
      foot.hidden = true;
      return;
    }

    foot.hidden = false;
    var subtotal = 0;

    var html = "";

    html += lines.map(function (l) {
      var p = lineProduct(l);
      var linePrice = l.line != null ? l.line : p.price * l.qty;
      subtotal += linePrice;
      return (
        '<div class="line">' +
          '<a class="line-media" href="' + productUrl(p) + '"><img src="' + (p.cardImages || p.images)[0].src + '" alt="' + esc((p.cardImages || p.images)[0].alt) + '" width="96" height="96"></a>' +
          '<div class="line-main">' +
            '<div class="line-top"><a class="line-name" href="' + productUrl(p) + '">' + esc(p.title) + "</a>" +
            '<button type="button" class="line-x" data-remove="' + esc(lineKey(l)) + '" aria-label="Retirer ' + esc(p.title) + '">' + ICON_X + "</button></div>" +
            '<span class="line-sub">' + esc(giftNote(l.handle, lines) || (p.color ? "Coloris : " + p.color : p.subtitle)) + "</span>" +
            '<div class="line-bottom"><span class="line-price tnum">' + money(linePrice) + "</span>" +
              '<div class="line-qty tnum">' +
                '<button type="button" aria-label="Diminuer la quantité" data-qty="' + esc(lineKey(l)) + '" data-delta="-1">&minus;</button>' +
                "<span>" + l.qty + "</span>" +
                '<button type="button" aria-label="Augmenter la quantité" data-qty="' + esc(lineKey(l)) + '" data-delta="1">+</button>' +
              "</div></div>" +
          "</div>" +
        "</div>"
      );
    }).join("");

    /* Suggestions: the add-ons of the products in the cart that are not in it yet, pack price first */
    var inCart = lines.map(function (l) { return l.handle; });
    var ups = [];
    lines.forEach(function (l) {
      var m = find(l.handle);
      ((m && m.addons) || []).forEach(function (h) {
        var a = find(h);
        if (!a || !shoppable(a) || inCart.indexOf(h) > -1 || ups.some(function (u) { return u.a === a; })) return;
        var pack = bundleFor(l.handle, h);
        /* One pack per unit of the main product: if another pack already uses it, suggest at full price.
           The welcome gift stays offered: with its code, Shopify keeps it over a pack (best value) */
        var used = lines.filter(function (x) { return bundleFor(l.handle, x.handle); }).reduce(function (n, x) { return n + x.qty; }, 0);
        if (used >= l.qty && !(pack && pack.code)) pack = null;
        ups.push({ a: a, pack: pack });
      });
    });
    ups.sort(function (x, y) { return (y.pack ? 1 : 0) - (x.pack ? 1 : 0); });
    ups.slice(0, 2).forEach(function (u) {
      var a = u.a;
      html +=
        '<div class="drawer-upsell">' +
          '<img src="' + (a.cardImages || a.images)[0].src + '" alt="" width="56" height="56">' +
          '<div><div>' + esc(a.title) + '</div><div class="small muted tnum">' +
            (u.pack ? (u.pack.code ? "Offert avec le code " + u.pack.code : money(a.price - u.pack.discount) + " avec le pack") : money(a.price)) + "</div></div>" +
          '<button type="button" class="pill" data-quick-add="' + a.handle + '">' + ICON_PLUS + "Ajouter</button>" +
        "</div>";
    });

    items.innerHTML = html;
    var discounts = SHOP ? shopDiscounts() : cartDiscounts(lines);
    var off = discounts.reduce(function (sum, d) { return sum + d.amount; }, 0);
    var discRow = $("[data-cart-discount]", drawer);
    discRow.hidden = !off;
    if (off) {
      $("dt", discRow).textContent = discounts.length > 1 ? "Remises packs" : discounts[0].label;
      $("dd", discRow).textContent = "−" + money(off);
    }
    var total = SHOP ? shopCart.total_price : subtotal - off;
    $("[data-cart-subtotal]", drawer).textContent = money(subtotal);
    $("[data-cart-total]", drawer).textContent = money(total);
    $("[data-cart-install]", drawer).textContent =
      total >= INSTALLMENT_MIN ? "ou 3 × " + installment(total, 3) + " sans frais" : "";
  }

  /* Menu ---------------------------------------------------------- */

  var ICON_MENU = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M4 9h16M4 15h16"/></svg>';
  var ICON_X = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  function setMenuButton(open) {
    var t = $(".menu-toggle");
    if (!t) return;
    t.setAttribute("aria-expanded", String(open));
    t.setAttribute("aria-label", open ? "Fermer le menu" : "Ouvrir le menu");
    t.innerHTML = open ? ICON_X : ICON_MENU;
  }

  function closeMenu() {
    document.documentElement.classList.remove("menu-open");
    setMenuButton(false);
  }

  function toggleMenu() {
    var panel = $(".menu-panel"), header = $(".site-header");
    if (panel && header) { panel.style.top = Math.max(0, header.getBoundingClientRect().bottom) + "px"; panel.scrollTop = 0; }
    var open = document.documentElement.classList.toggle("menu-open");
    setMenuButton(open);
    document.body.classList.toggle("is-locked", open);
  }

  /* Sheets (modals) ----------------------------------------------- */

  function openSheet(id) {
    var sheet = document.getElementById(id);
    if (!sheet) return;
    lastFocus = document.activeElement;
    sheet.classList.add("is-open");
    sheet.setAttribute("aria-hidden", "false");
    document.body.classList.add("is-locked");
    var v = $("video", sheet);
    if (v) { v.currentTime = 0; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    var c = $(".sheet-close", sheet);
    if (c) setTimeout(function () { c.focus(); }, 50);
  }

  function closeSheets() {
    $$(".sheet.is-open").forEach(function (s) {
      s.classList.remove("is-open");
      s.setAttribute("aria-hidden", "true");
      var v = $("video", s);
      if (v) v.pause();
      document.body.classList.remove("is-locked");
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    });
  }

  /* Product cards ------------------------------------------------- */

  function card(p) {
    var imgs = p.cardImages || p.images;
    var second = imgs[1]
      ? '<img src="' + imgs[1].src + '" alt="" loading="lazy" width="800" height="1000">'
      : "";
    var old = p.compareAt ? ' <s class="muted">' + money(p.compareAt) + "</s>" : "";
    return (
      '<a class="card" href="' + productUrl(p) + '">' +
        '<div class="card-media">' +
          '<img src="' + imgs[0].src + '" alt="' + esc(imgs[0].alt) + '" loading="lazy" width="800" height="1000">' +
          second +
        "</div>" +
        '<div class="card-meta"><span>' + esc(p.title) + '</span><span class="tnum">' + money(p.price) + old + "</span></div>" +
        (p.ja ? '<span class="card-ja ja" lang="ja">' + esc(p.ja) + "</span>" : "") +
        '<span class="card-sub small">' + esc(p.subtitle) + "</span>" +
      "</a>"
    );
  }

  function renderCards(el, list) {
    el.innerHTML = list.map(card).join("");
  }

  function shoppable(p) { return p.type !== "service"; }

  /* FAQ ----------------------------------------------------------- */

  function renderFaq(el, limit) {
    renderFaqList(el, limit ? FAQ.slice(0, limit) : FAQ);
  }

  function renderFaqList(el, list) {
    el.innerHTML = list.map(function (q) {
      return "<details><summary>" + esc(q[0]) + '</summary><div class="panel"><p>' + esc(q[1]) + "</p></div></details>";
    }).join("");
  }

  /* Tabs ---------------------------------------------------------- */

  function initTabs(root) {
    $$("[data-tabs]", root).forEach(function (group) {
      var buttons = $$("[role=tab]", group);
      buttons.forEach(function (b) {
        b.addEventListener("click", function () {
          buttons.forEach(function (x) {
            var on = x === b;
            x.setAttribute("aria-selected", String(on));
            document.getElementById(x.getAttribute("aria-controls")).hidden = !on;
          });
        });
      });
    });
  }

  /* Pages --------------------------------------------------------- */

  function modelCard(p) {
    var img = (p.cardImages || p.images)[0];
    var old = p.compareAt ? ' <s class="muted">' + money(p.compareAt) + "</s>" : "";
    return (
      '<a class="model" href="' + productUrl(p) + '">' +
        '<div class="model-media"><img src="' + img.src + '" alt="' + esc(img.alt) + '" loading="lazy" width="800" height="800"></div>' +
        '<div class="model-body">' +
          '<p class="model-price tnum">' + money(p.price) + old + "</p>" +
          (p.fit ? '<p class="model-fit">' + esc(p.fit) + "</p>" : "") +
          "<h3>" + esc(p.title) + "</h3>" +
          (p.ja ? '<span class="card-ja ja" lang="ja">' + esc(p.ja) + "</span>" : "") +
          '<ul class="checks">' + (p.highlights || []).map(function (h) { return "<li>" + ICON_CHECK + "<span>" + esc(h) + "</span></li>"; }).join("") + "</ul>" +
          '<span class="pill pill--solid">' + (p.type === "accessory" ? "Voir" : "Découvrir") + "</span>" +
        "</div>" +
      "</a>"
    );
  }

  function initRail() {
    var root = $("[data-rail]");
    if (!root) return;
    var track = $("[data-rail-track]", root);
    var bar = $("[data-rail-bar]", root);
    var prev = $("[data-rail-prev]", root);
    var next = $("[data-rail-next]", root);
    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      var ratio = track.clientWidth / track.scrollWidth;
      var pos = max > 0 ? track.scrollLeft / max : 0;
      bar.style.width = (ratio * 100) + "%";
      bar.style.transform = "translateX(" + (pos * (1 / ratio - 1) * 100) + "%)";
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }
    function step(dir) {
      var card = $(".rail-card", track);
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: reduceMotion ? "auto" : "smooth" });
    }
    prev.addEventListener("click", function () { step(-1); });
    next.addEventListener("click", function () { step(1); });
    track.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);
    sync();
  }

  function initHome() {
    var el = $("[data-accessories]");
    if (el) renderCards(el, PRODUCTS.filter(function (p) { return p.type === "accessory"; }).slice(0, 3));
    var models = $("[data-models]");
    if (models) models.innerHTML = ["kiyohako-one", "kiyohako-duo"].map(find).filter(Boolean).map(modelCard).join("");
    var acc = $("[data-home-acc]");
    if (acc) {
      var accs = PRODUCTS.filter(function (p) { return p.type === "accessory"; });
      acc.innerHTML = accs.slice(0, 3).map(shopCard).join("");
      $("[data-home-acc-section]").hidden = !accs.length;
    }
    initRail();
    var duoPrice = $("[data-duo-price]"), duo = find("kiyohako-duo");
    if (duoPrice && duo) duoPrice.textContent = money(duo.price) + " ou 3 × " + installment(duo.price, 3) + " sans frais";
    var faq = $("[data-faq]");
    if (faq) renderFaq(faq, 5);
  }

  var SHOP_CATS = {
    all: { title: "Boutique", lead: "Kiyohako One, Kiyohako Duo et la maison du chat. Livraison offerte, retour sous 14 jours.", img: asset("assets/images/life-scale.webp") },
    "litter-box": { title: "Litière autonettoyante", lead: "Kiyohako One se nettoie seule après chaque passage. Vous n’avez plus qu’à vider le tiroir.", img: asset("assets/images/life-living.webp") },
    feeder: { title: "Repas et eau", lead: "Kiyohako Duo : les croquettes à l’heure, l’eau toujours fraîche, pilotés depuis l’application.", img: asset("assets/images/duo-kitchen.webp"), pos: "50% 74%" },
    accessory: { title: "La maison du chat", lead: "Un lit, un arbre à chat et un tapis, choisis pour aller avec Kiyohako One et Kiyohako Duo.", img: asset("assets/images/lit-petale-salon.webp"), pos: "50% 70%" }
  };

  function shopCard(p) {
    var imgs = p.cardImages || p.images;
    var old = p.compareAt ? ' <s class="muted">' + money(p.compareAt) + "</s>" : "";
    var inst = p.price >= INSTALLMENT_MIN ? '<span class="shop-card-inst tnum">ou 3 × ' + installment(p.price, 3) + " sans frais</span>" : "";
    return (
      '<a class="shop-card" href="' + productUrl(p) + '">' +
        '<div class="shop-card-media">' +
          (p.badge ? '<span class="shop-badge">' + esc(p.badge) + "</span>" : "") +
          '<img src="' + imgs[0].src + '" alt="' + esc(imgs[0].alt) + '" loading="lazy" width="800" height="800">' +
          (imgs[1] ? '<img src="' + imgs[1].src + '" alt="" loading="lazy" width="800" height="800">' : "") +
        "</div>" +
        '<div class="shop-card-body">' +
          "<h3>" + esc(p.title) + "</h3>" +
          '<p class="shop-card-sub">' + esc(p.subtitle) + "</p>" +
          '<p class="shop-card-price tnum">' + money(p.price) + old + "</p>" + inst +
        "</div>" +
      "</a>"
    );
  }

  function packTile() {
    return (
      '<a class="shop-pack" href="' + link("kiyohako-one.html") + '">' +
        '<img src="' + asset("assets/images/life-drawer.webp") + '" alt="" loading="lazy" width="800" height="800">' +
        '<div><h3>Kiyohako One + Kiyohako Duo</h3><p>20 € de moins sur le pack, appliqués dans le panier.</p><span class="pill pill--light">Composer mon pack</span></div>' +
      "</a>"
    );
  }

  function initCollection() {
    var grid = $("[data-collection]");
    if (!grid) return;

    var params = new URLSearchParams(window.location.search);
    var state = { type: params.get("type") || "all", sort: "featured" };
    if (!SHOP_CATS[state.type]) state.type = "all";

    $$("[data-n]").forEach(function (el) {
      var t = el.getAttribute("data-n");
      var n = PRODUCTS.filter(shoppable).filter(function (p) { return t === "all" || p.type === t; }).length;
      el.textContent = n;
      /* A category with nothing published yet (draft products in Shopify) is not offered */
      var b = el.closest("[data-filter]");
      if (b && !n) b.hidden = true;
      if (!n && state.type === t) state.type = "all";
    });

    function apply() {
      var list = PRODUCTS.filter(shoppable).filter(function (p) { return state.type === "all" || p.type === state.type; });
      if (state.sort === "price-asc") list = list.slice().sort(function (a, b) { return a.price - b.price; });
      if (state.sort === "price-desc") list = list.slice().sort(function (a, b) { return b.price - a.price; });
      var html = list.map(shopCard);
      if (state.type === "all" || state.type === "litter-box") html.splice(Math.min(3, html.length), 0, packTile());
      grid.innerHTML = html.join("");

      var cat = SHOP_CATS[state.type];
      $("[data-shop-title]").textContent = cat.title;
      $("[data-shop-lead]").textContent = cat.lead;
      var img = $("[data-shop-img]");
      if (img.getAttribute("src") !== cat.img) img.setAttribute("src", cat.img);
      img.style.objectPosition = cat.pos || "";
      $("[data-crumb-cat]").textContent = state.type === "all" ? "" : cat.title;
      $("[data-crumb-sep]").hidden = state.type === "all";

      $("[data-count]").textContent = list.length + (list.length === 1 ? " produit" : " produits");
      $$("[data-filter]").forEach(function (b) {
        var on = b.getAttribute("data-filter") === state.type;
        b.setAttribute("aria-pressed", String(on));
        if (on && b.parentNode.scrollWidth > b.parentNode.clientWidth) b.parentNode.scrollTo({ left: b.offsetLeft - 16, behavior: "smooth" });
      });

      var url = link(state.type === "all" ? "collection.html" : "collection.html?type=" + state.type);
      try { window.history.replaceState(null, "", url); } catch (e) {}
    }

    $$("[data-filter]").forEach(function (b) {
      b.addEventListener("click", function () { state.type = b.getAttribute("data-filter"); apply(); });
    });

    $("[data-sort]").addEventListener("change", function (e) { state.sort = e.target.value; apply(); });

    apply();
  }

  function initGallery(p) {
    var slidesEl = $("[data-slides]");
    var thumbsEl = $("[data-thumbs]");
    var counter = $("[data-gallery-count]");

    var media = p.images.map(function (img) { return { type: "image", src: img.src, alt: img.alt }; });
    if (p.video) media.splice(1, 0, { type: "video", src: p.video.src, poster: p.video.poster, alt: p.video.alt });

    // The first photo is already in the HTML (shown before this script runs): keep it, fix it if another colour is chosen
    var pre = $(".slide", slidesEl);
    if (pre) {
      var preImg = $("img", pre), file = function (u) { return String(u).split("?")[0].split("/").pop(); };
      if (file(preImg.getAttribute("src")) !== file(media[0].src)) preImg.src = media[0].src;
      preImg.alt = media[0].alt;
    }

    slidesEl.insertAdjacentHTML("beforeend", media.map(function (m, i) {
      if (i === 0 && pre) return "";
      if (m.type === "video") {
        return '<div class="slide slide--video"><video muted loop playsinline preload="none" poster="' + m.poster + '" data-src="' + m.src + '" aria-label="' + esc(m.alt) + '"></video>' +
          '<button type="button" class="slide-sound" data-sound aria-pressed="false" aria-label="Activer le son">' + ICON_SOUND_OFF + "</button></div>";
      }
      return '<div class="slide"><img src="' + m.src + '" alt="' + esc(m.alt) + '" width="1600" height="1600"' + (i > 1 ? ' loading="lazy"' : "") + "></div>";
    }).join(""));

    thumbsEl.innerHTML = media.map(function (m, i) {
      var src = m.type === "video" ? m.poster : m.src;
      var play = m.type === "video"
        ? '<span class="thumb-play"><span><svg width="11" height="12" viewBox="0 0 11 12" aria-hidden="true"><path d="M1.5 1.2v9.6a.6.6 0 0 0 .9.5l8-4.8a.6.6 0 0 0 0-1L2.4.7a.6.6 0 0 0-.9.5z" fill="currentColor"/></svg></span></span>'
        : "";
      return '<button type="button" class="thumb" data-goto="' + i + '" aria-label="' + (m.type === "video" ? "Vidéo" : "Photo " + (i + 1)) + '"' + (i === 0 ? ' aria-current="true"' : "") + ">" +
        '<img src="' + src + '" alt="" width="160" height="160" loading="lazy">' + play + "</button>";
    }).join("");

    var slides = $$(".slide", slidesEl);
    var current = 0;

    slidesEl.addEventListener("click", function (e) {
      var b = e.target.closest("[data-sound]");
      if (!b) return;
      var v = $("video", b.parentNode);
      v.muted = !v.muted;
      if (!v.muted) { v.currentTime = 0; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      b.setAttribute("aria-pressed", String(!v.muted));
      b.setAttribute("aria-label", v.muted ? "Activer le son" : "Couper le son");
      b.innerHTML = v.muted ? ICON_SOUND_OFF : ICON_SOUND_ON;
    });
    var up = $("[data-thumbs-up]");
    var down = $("[data-thumbs-down]");

    function syncArrows() {
      if (!up || !down) return;
      var max = thumbsEl.scrollHeight - thumbsEl.clientHeight;
      var vertical = getComputedStyle(thumbsEl).position === "absolute";
      up.hidden = !vertical || thumbsEl.scrollTop <= 4;
      down.hidden = !vertical || thumbsEl.scrollTop >= max - 4;
    }
    function step(dir) {
      var t = $(".thumb", thumbsEl);
      var h = t ? t.getBoundingClientRect().height + 8 : 120;
      thumbsEl.scrollBy({ top: dir * h * 3, behavior: reduceMotion ? "auto" : "smooth" });
    }
    if (up) up.addEventListener("click", function () { step(-1); });
    if (down) down.addEventListener("click", function () { step(1); });
    thumbsEl.addEventListener("scroll", syncArrows, { passive: true });
    window.addEventListener("resize", syncArrows);

    function setCurrent(i) {
      current = i;
      counter.textContent = i + 1 + " / " + slides.length;
      $$(".thumb", thumbsEl).forEach(function (t, k) { t.setAttribute("aria-current", String(k === i)); });
      var active = $$(".thumb", thumbsEl)[i];
      if (active && getComputedStyle(thumbsEl).position === "absolute") {
        var top = active.offsetTop, bottom = top + active.offsetHeight;
        if (top < thumbsEl.scrollTop) thumbsEl.scrollTop = top - 8;
        else if (bottom > thumbsEl.scrollTop + thumbsEl.clientHeight) thumbsEl.scrollTop = bottom - thumbsEl.clientHeight + 8;
      }
      slides.forEach(function (s, k) {
        var v = $("video", s);
        if (!v) return;
        if (k === i && !reduceMotion) {
          if (!v.src) v.src = v.getAttribute("data-src");
          var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
        } else {
          v.pause();
          var sb = $("[data-sound]", s);
          if (sb && !v.muted) { v.muted = true; sb.setAttribute("aria-pressed", "false"); sb.setAttribute("aria-label", "Activer le son"); sb.innerHTML = ICON_SOUND_OFF; }
        }
      });
    }

    thumbsEl.addEventListener("click", function (e) {
      var t = e.target.closest("[data-goto]");
      if (!t) return;
      var i = Number(t.getAttribute("data-goto"));
      slidesEl.scrollTo({ left: slidesEl.clientWidth * i, behavior: reduceMotion ? "auto" : "smooth" });
      setCurrent(i);
    });

    var ticking = false;
    slidesEl.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(slidesEl.scrollLeft / slidesEl.clientWidth);
        if (i !== current) setCurrent(i);
        ticking = false;
      });
    }, { passive: true });

    setCurrent(0);
    requestAnimationFrame(syncArrows);
    window.addEventListener("load", syncArrows);

    /* Colour change: same number of photos, swapped in place */
    return function show(images) {
      var k = 0;
      media.forEach(function (m, i) {
        if (m.type !== "image" || !images[k]) return;
        var img = images[k++];
        var s = $("img", slides[i]), t = $("img", $$(".thumb", thumbsEl)[i]);
        s.src = img.src; s.alt = img.alt;
        if (t) t.src = img.src;
      });
      slidesEl.scrollTo({ left: 0, behavior: "auto" });
      setCurrent(0);
    };
  }

  /* SEO / Google Merchant: canonical URL and Product structured data */
  function injectProductData(p) {
    if (SHOP) return; // rendered server-side by the product section
    var siteMeta = $('meta[name="site-url"]');
    var site = siteMeta ? siteMeta.getAttribute("content") : location.origin;
    var url = site + "/" + p.handle + ".html";
    var head = document.head;
    if (!$('link[rel="canonical"]')) { var link = document.createElement("link"); link.rel = "canonical"; link.href = url; head.appendChild(link); }
    var og = $('meta[property="og:url"]'); if (og) og.setAttribute("content", url);
    var ogt = $('meta[property="og:title"]'); if (ogt) ogt.setAttribute("content", p.title + " — Kiyohako");
    var ogi = $('meta[property="og:image"]');
    var imgs = (p.merchantImages || (p.cardImages || p.images).map(function (i) { return i.src; }));
    if (ogi) ogi.setAttribute("content", site + "/" + imgs[0]);
    var desc = $('meta[name="description"]'); if (desc) desc.setAttribute("content", p.description);
    if (p.type === "service" || $("script[data-static-product]")) return;
    var data = {
      "@context": "https://schema.org",
      "@type": "Product",
      name: p.title,
      description: p.description,
      sku: p.sku || p.handle,
      mpn: p.sku || p.handle,
      brand: { "@type": "Brand", name: "Kiyohako" },
      image: imgs.map(function (i) { return site + "/" + i; }),
      offers: {
        "@type": "Offer",
        url: url,
        priceCurrency: "EUR",
        price: (p.price / 100).toFixed(2),
        availability: "https://schema.org/InStock",
        itemCondition: "https://schema.org/NewCondition",
        shippingDetails: {
          "@type": "OfferShippingDetails",
          shippingRate: { "@type": "MonetaryAmount", value: "0", currency: "EUR" },
          shippingDestination: { "@type": "DefinedRegion", addressCountry: "FR" },
          deliveryTime: {
            "@type": "ShippingDeliveryTime",
            handlingTime: { "@type": "QuantitativeValue", minValue: 0, maxValue: 2, unitCode: "DAY" },
            transitTime: { "@type": "QuantitativeValue", minValue: (p.delivery || DEFAULT_DELIVERY)[0], maxValue: (p.delivery || DEFAULT_DELIVERY)[1] - 2, unitCode: "DAY" }
          }
        },
        hasMerchantReturnPolicy: {
          "@type": "MerchantReturnPolicy",
          applicableCountry: "FR",
          returnPolicyCategory: "https://schema.org/MerchantReturnFiniteReturnWindow",
          merchantReturnDays: 14,
          returnMethod: "https://schema.org/ReturnByMail",
          returnFees: "https://schema.org/ReturnFeesCustomerResponsibility"
        }
      }
    };
    if (p.color) data.color = p.color;
    if (p.rating && p.reviews) data.aggregateRating = { "@type": "AggregateRating", ratingValue: p.rating, reviewCount: p.reviews };
    var script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(data);
    head.appendChild(script);
  }

  function initProduct() {
    var root = $("[data-pdp]");
    if (!root) return;

    var handle = new URLSearchParams(window.location.search).get("handle") || document.body.getAttribute("data-handle") || "kiyohako-one";
    var p = find(handle);
    if (!p || !shoppable(p)) p = PRODUCTS[0];
    var isBox = p.type === "litter-box";

    if (!document.body.getAttribute("data-handle")) document.title = p.title + " — Kiyohako";
    injectProductData(p);
    $$("[data-only]").forEach(function (el) {
      var only = el.getAttribute("data-only");
      el.hidden = only === "other" ? isBox : only !== p.type;
    });
    $$(".header-nav a, .menu-panel a").forEach(function (a) {
      if (a.getAttribute("href") === productUrl(p)) a.setAttribute("aria-current", "page");
    });
    if (!isBox) $$('.subnav-links a[href="#caracteristiques"]').forEach(function (a) { a.setAttribute("href", "#caracteristiques-acc"); });

    $$("[data-title]").forEach(function (el) { el.textContent = p.title; });
    var crumb = $("[data-crumb]");
    if (crumb) crumb.textContent = p.title;
    var rating = $("[data-rating]");
    if (rating && (p.type === "litter-box" || p.type === "feeder")) {
      var STAR = function (fill) {
        var id = "g" + Math.random().toString(36).slice(2, 7);
        return '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><defs><linearGradient id="' + id + '"><stop offset="' + fill + '" stop-color="currentColor"/><stop offset="' + fill + '" stop-color="currentColor" stop-opacity="0"/></linearGradient></defs>' +
          '<path d="M12 2.8l2.8 5.8 6.3.9-4.6 4.4 1.1 6.3L12 17.2l-5.6 3 1.1-6.3L2.9 9.5l6.3-.9z" fill="url(#' + id + ')" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>';
      };
      var stars = "";
      for (var k = 0; k < 5; k++) stars += STAR(p.rating ? Math.max(0, Math.min(1, p.rating - k)) : 0);
      /* Shown only once there are real reviews; until then reviews are collected in the "Avis clients" section */
      if (p.rating && p.reviews) {
        rating.innerHTML = '<span class="pdp-stars">' + stars + '</span><span class="tnum">(' + String(p.rating).replace(".", ",") + "/5) " + p.reviews + " avis</span>";
        rating.setAttribute("aria-label", "Note " + p.rating + " sur 5, " + p.reviews + " avis");
        rating.hidden = false;
      }
    }
    var reviewLink = $("[data-review-link]");
    if (reviewLink) {
      reviewLink.href = reviewLink.getAttribute("href").split("?")[0] +
        "?subject=" + encodeURIComponent("Mon avis sur " + p.title) +
        "&body=" + encodeURIComponent("Numéro de commande :\nNote sur 5 :\nMon avis :\n");
    }

    var ja = $("[data-ja]");
    if (ja) { ja.textContent = p.ja || ""; ja.hidden = !p.ja; }
    var sub = $("[data-subtitle]");
    if (sub) sub.textContent = p.subtitle || "";
    $("[data-price]").textContent = money(p.price);
    var old = $("[data-price-old]");
    if (p.compareAt) { old.textContent = money(p.compareAt); old.hidden = false; }

    var eco = $("[data-eco]");
    if (eco && p.ecoFee) { eco.textContent = "Dont éco-participation : " + money(p.ecoFee); eco.hidden = false; }

    var inst = $("[data-installments]");
    if (p.price >= INSTALLMENT_MIN) {
      inst.innerHTML = "ou <strong class=\"tnum\">3 × " + installment(p.price, 3) + "</strong> sans frais<br>avec Klarna";
    } else {
      inst.hidden = true;
    }

    var eta = $("[data-eta]");
    if (eta) {
      var mq = window.matchMedia("(max-width: 600px)");
      var setEta = function () { eta.textContent = deliveryWindow(mq.matches, deliveryRange([p])); };
      setEta();
      if (mq.addEventListener) mq.addEventListener("change", setEta);
      $("[data-eta-wrap]").hidden = false;
      var dr = deliveryRange([p]);
      $$("[data-delivery-note]").forEach(function (n) { n.textContent = "(" + dr[0] + " à " + dr[1] + " jours ouvrés)"; });
    }

    $("[data-benefits]").innerHTML = checks(p.benefits || p.includes || []);
    $("[data-overview]").textContent = p.description;

    /* Colour: ?variant=<id> on Shopify, ?couleur=<name> on the static site */
    var params = new URLSearchParams(window.location.search);
    var start = p.color;
    (p.colors || []).forEach(function (c) {
      if (SHOP ? String(shopVariant(p, c.name).id) === params.get("variant") : c.name.toLowerCase() === (params.get("couleur") || "").toLowerCase()) start = c.name;
    });
    if (p.colors) chosen[p.handle] = start;
    if (p.color) {
      $("[data-color]").textContent = start + " · " + p.shipping;
      $("[data-swatches]").innerHTML = (p.colors || [{ name: p.color }]).map(function (c) {
        var sw = (inColor(p, c.name).cardImages || inColor(p, c.name).images)[0];
        return '<button type="button" class="swatch" data-swatch="' + esc(c.name) + '" aria-pressed="' + (c.name === start) + '"><img src="' + sw.src + '" alt="" width="44" height="44">' + esc(c.name) + "</button>";
      }).join("");
      // A single colour: nothing to choose, so no block (the photo shows it, the delivery line gives the dates)
      $("[data-swatch-wrap]").hidden = !p.colors;
    }

    $("[data-specs]").innerHTML = p.specs.map(function (s) {
      return "<div><dt>" + esc(s[0]) + "</dt><dd>" + esc(s[1]) + "</dd></div>";
    }).join("");
    $("[data-inbox]").innerHTML = checks(p.inBox);

    function rows(list) {
      return (list || []).map(function (s) { return "<div><dt>" + esc(s[0]) + "</dt><dd>" + esc(s[1]) + "</dd></div>"; }).join("");
    }
    if (isBox) {
      $("[data-dims]").innerHTML = rows(p.dimSpecs);
      $("[data-compat]").innerHTML = rows(p.compat);
      var safety = $("[data-safety]");
      if (safety) safety.innerHTML = rows(p.safety);
      $("[data-inbox-tech]").innerHTML = checks(p.inBox);
      if (p.dims) {
        $("[data-dim-w]").textContent = p.dims.width;
        $("[data-dim-h]").textContent = p.dims.height;
        $("[data-dim-d]").textContent = p.dims.depth;
      }
    }

    var showImages = initGallery(inColor(p, start));
    if (p.colors) $("[data-swatches]").addEventListener("click", function (e) {
      var b = e.target.closest("[data-swatch]");
      if (!b || b.getAttribute("aria-pressed") === "true") return;
      var name = b.getAttribute("data-swatch");
      chosen[p.handle] = name;
      $$("[data-swatch]").forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
      $("[data-color]").textContent = name + " · " + p.shipping;
      showImages(inColor(p, name).images);
      syncAvailability();
      var q = new URLSearchParams(window.location.search);
      q.delete(SHOP ? "variant" : "couleur");
      if (name !== p.colors[0].name || SHOP) q.set(SHOP ? "variant" : "couleur", SHOP ? shopVariant(p, name).id : name.toLowerCase());
      try { window.history.replaceState(null, "", window.location.pathname + (String(q) ? "?" + q : "") + window.location.hash); } catch (err) {}
    });

    /* Add-ons */
    var selected = [];
    var addonsEl = $("[data-addons]");
    if (addonsEl && p.addons) {
      addonsEl.innerHTML = p.addons.filter(find).map(function (h) {
        var a = find(h);
        var o = a.offer || {};
        var pack = bundleFor(p.handle, a.handle);
        /* A welcome gift (pack with a code) reads "Offert", its condition in the description */
        var gift = pack && pack.code && pack.discount >= a.price;
        var price = gift ? "Offert" : money(pack ? a.price - pack.discount : a.price);
        var old = pack ? "" : a.compareAt ? money(a.compareAt) : "";
        var desc = o.desc || a.subtitle;
        if (gift) desc += " Code " + pack.code + " appliqué au paiement (1re commande), valeur " + money(a.price) + ".";
        else if (pack) desc = desc.replace(/\.$/, "") + ", −" + money(pack.discount) + " en pack.";
        var fullDesc = (o.desc || a.subtitle).replace(/\.$/, "") + ".";
        /* No free-mat code running (Halloween offer): no "offert" heading either */
        var heading = gift || !/offert/i.test(o.heading || "") ? o.heading : "Ajoutez le " + a.title.toLowerCase();
        var body = "";
        if (o.media) body += '<img class="offer-media" src="' + o.media.src + '" alt="' + esc(o.media.alt) + '" width="1080" height="1350" loading="lazy">';
        if (o.features) body += '<ul class="offer-feats">' + o.features.map(function (f) { return "<li><strong>" + esc(f[0]) + "</strong><span>" + esc(f[1]) + "</span></li>"; }).join("") + "</ul>";
        if (o.checks) body += '<ul class="offer-checks">' + o.checks.map(function (c) { return "<li>" + ICON_CHECK + "<span>" + esc(c) + "</span></li>"; }).join("") + "</ul>";
        return '<div class="offer-group" data-offer="' + a.handle + '">' +
          (heading ? '<p class="offer-head">' + esc(heading) + "</p>" : "") +
          '<div class="offer">' +
            '<div class="offer-top' + (o.thumb ? " offer-top--thumb" : "") + '">' +
              (o.thumb ? '<img class="offer-thumb" src="' + (a.cardImages || a.images)[0].src + '" alt="" width="72" height="72" loading="lazy">' : "") +
              '<div><p class="offer-name">' + esc(o.title || a.title) + ' <span class="offer-price tnum" data-pack-price="' + esc(price) + '" data-full-price="' + esc(money(a.price)) + '">' + price + (old ? " <s>" + old + "</s>" : "") + "</span></p>" +
              '<p class="offer-desc"><span data-pack-desc="' + esc(desc) + '" data-full-desc="' + esc(fullDesc) + '">' + esc(desc) + '</span> <button type="button" class="addon-info" aria-label="En savoir plus sur ' + esc(a.title) + '" data-offer-open="' + a.handle + '">?</button></p></div>' +
              '<button type="button" class="pill" aria-pressed="false" data-addon="' + a.handle + '">' + ICON_PLUS + "<span>Ajouter</span></button>" +
            "</div>" + body +
          "</div></div>";
      }).join("");

      function openOffer(h) {
        var a = find(h), sh = (a.offer && a.offer.sheet) || {};
        var sheet = $("#sheet-offer");
        if (!sheet) return;
        var img = $("[data-offer-img]", sheet);
        img.src = sh.img || (a.cardImages || a.images)[0].src;
        img.alt = a.title;
        $("[data-offer-title]", sheet).textContent = sh.title || a.title;
        $("[data-offer-text]", sheet).textContent = a.description;
        $("[data-offer-list]", sheet).innerHTML = (sh.list || a.benefits || []).map(function (t) {
          return "<li><span>" + esc(t) + '</span><span class="offer-sheet-tick">' + ICON_TICK + "</span></li>";
        }).join("");
        var rev = $("[data-offer-reviews]", sheet);
        rev.hidden = a.type === "service";
        if (!rev.hidden) {
          var r = $("[data-offer-rating]", sheet);
          r.setAttribute("href", productUrl(a) + "#avis");
          r.removeAttribute("data-sheet-close");
          r.innerHTML = a.rating && a.reviews
            ? '<span class="pdp-stars">★★★★★</span><span class="tnum">(' + String(a.rating).replace(".", ",") + "/5) " + a.reviews + " avis</span>"
            : "<span>Pas encore d’avis : ils s’afficheront ici après les premières commandes.</span>";
        }
        openSheet("sheet-offer");
      }

      addonsEl.addEventListener("click", function (e) {
        var info = e.target.closest("[data-offer-open]");
        var b = e.target.closest("[data-addon]");
        if (info || (!b && e.target.closest(".offer-top"))) { openOffer(info ? info.getAttribute("data-offer-open") : e.target.closest("[data-offer]").getAttribute("data-offer")); return; }
        if (!b) return;
        var h = b.getAttribute("data-addon");
        var on = b.getAttribute("aria-pressed") !== "true";
        b.setAttribute("aria-pressed", String(on));
        b.innerHTML = (on ? ICON_TICK : ICON_PLUS) + "<span>" + (on ? "Ajouté" : "Ajouter") + "</span>";
        var card = b.closest(".offer");
        if (card) card.classList.toggle("is-added", on);
        selected = on ? selected.concat(h) : selected.filter(function (x) { return x !== h; });
        updateTotal();
      });
    }

    /* The pack that applies to this product: the best one among the selected add-ons (Shopify allows one) */
    function bestPack() {
      return selected.reduce(function (best, h) {
        var pack = bundleFor(p.handle, h);
        return pack && (!best || pack.discount > best.discount) ? pack : best;
      }, null);
    }

    function total() {
      var best = bestPack();
      return selected.reduce(function (sum, h) { return sum + find(h).price; }, p.price) - (best ? best.discount : 0);
    }

    function updateTotal() {
      $$("[data-atc-price]").forEach(function (el) { el.textContent = money(total()); });
      /* An add-on keeps its pack price unless a better pack is already selected */
      var best = bestPack();
      $$("[data-addons] [data-offer]").forEach(function (g) {
        var h = g.getAttribute("data-offer"), pack = bundleFor(p.handle, h);
        if (!pack) return;
        var full = best && best.item !== h && best.discount >= pack.discount;
        var pr = $("[data-pack-price]", g), ds = $("[data-pack-desc]", g);
        if (pr) pr.textContent = full ? pr.getAttribute("data-full-price") : pr.getAttribute("data-pack-price");
        if (ds) ds.textContent = full ? ds.getAttribute("data-full-desc") + (best.code ? " Le pack −" + money(pack.discount) + " ne se cumule pas avec le " + best.label.toLowerCase() + "." : " Remise pack non cumulable avec " + find(best.item).title + ".") : ds.getAttribute("data-pack-desc");
      });
    }

    function buy() {
      addToCart([p.handle].concat(selected));
      openCart();
    }

    var addLabels = [];
    function syncAvailability() {
      if (!SHOP) return;
      var ok = shopVariant(p, chosenColor(p)).available;
      $$("[data-add]").forEach(function (b, i) {
        if (addLabels[i] == null) addLabels[i] = b.innerHTML;
        b.disabled = !ok;
        if (ok) b.innerHTML = addLabels[i]; else b.textContent = "Bientôt disponible";
      });
      if (ok) updateTotal();
    }
    $$("[data-add]").forEach(function (b) { b.addEventListener("click", buy); });
    updateTotal();
    syncAvailability();

    /* Quick-add bundle */
    $$("[data-quick-add]", root.parentNode).forEach(function (b) {
      b.addEventListener("click", function () { addToCart([b.getAttribute("data-quick-add")]); openCart(); });
    });

    /* FAQ */
    var faq = $("[data-faq]");
    if (faq) {
      if (p.faq) renderFaqList(faq, p.faq.concat(FAQ.slice(7, 8)));
      else renderFaq(faq);
    }

    /* Mobile buy bar: on phones the main button sits two screens down, below the benefits and add-ons,
       so the bar shows as soon as the visitor scrolls and hides while the main button is on screen */
    var atc = $(".btn-atc");
    var buybar = $("[data-buybar]");
    if (atc && buybar) {
      var syncBar = function () {
        var r = atc.getBoundingClientRect();
        var onScreen = r.bottom > 0 && r.top < window.innerHeight;
        buybar.classList.toggle("is-visible", !onScreen && window.scrollY > 120);
      };
      window.addEventListener("scroll", syncBar, { passive: true });
      window.addEventListener("resize", syncBar);
      syncBar();
    }

    /* Sub-nav: sticks to the top and takes over from the header */
    var subnav = $("[data-subnav]");
    if (subnav) {
      var sentinel = document.createElement("div");
      sentinel.className = "subnav-sentinel";
      sentinel.setAttribute("aria-hidden", "true");
      subnav.parentNode.insertBefore(sentinel, subnav);
      var links = $$(".subnav-links a", subnav);
      var ticking = false;
      function syncSubnav() {
        ticking = false;
        var stuck = sentinel.getBoundingClientRect().top < 0;
        subnav.classList.toggle("is-stuck", stuck);
        document.documentElement.classList.toggle("subnav-stuck", stuck);
        var line = subnav.getBoundingClientRect().bottom + 48;
        var active = -1;
        links.forEach(function (a, i) {
          var t = a.hidden ? null : document.querySelector(a.getAttribute("href"));
          if (t && !t.hidden && t.getBoundingClientRect().top <= line) active = i;
        });
        links.forEach(function (a, i) { a.classList.toggle("is-active", stuck && i === active); });
      }
      window.addEventListener("scroll", function () {
        if (!ticking) { ticking = true; requestAnimationFrame(syncSubnav); }
      }, { passive: true });
      window.addEventListener("resize", syncSubnav);
      syncSubnav();

      $$(".subnav-links a", subnav).forEach(function (a) {
        a.addEventListener("click", function (e) {
          var t = document.querySelector(a.getAttribute("href"));
          if (!t) return;
          e.preventDefault();
          var y = t.getBoundingClientRect().top + window.scrollY - subnav.offsetHeight - 8;
          window.scrollTo({ top: y, behavior: reduceMotion ? "auto" : "smooth" });
        });
      });

      var toBuy = $("[data-to-buy]", subnav);
      if (toBuy) toBuy.addEventListener("click", function () {
        var y = $(".pdp-buy").getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({ top: y, behavior: reduceMotion ? "auto" : "smooth" });
      });
    }

    initTabs(root);
  }

  /* Announcement + hero video ------------------------------------ */

  /* Time-limited offers (data-until): gone from the page once the end date has passed */
  function expireOffers() {
    $$("[data-until]").forEach(function (el) {
      if (Date.now() > Date.parse(el.getAttribute("data-until"))) el.parentNode.removeChild(el);
    });
  }

  function initAnnounce() {
    var bar = $("[data-announce]");
    if (!bar) return;
    var items = $$("p", bar);
    if (items.length && !$("p.is-active", bar)) items[0].classList.add("is-active");
    if (items.length < 2 || reduceMotion) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove("is-active");
      i = (i + 1) % items.length;
      items[i].classList.add("is-active");
    }, 4000);
  }

  function initHeroVideo() {
    var video = $("[data-hero-video]");
    if (!video || reduceMotion) return;
    var small = window.matchMedia("(max-width: 760px)").matches;
    video.src = video.getAttribute(small ? "data-src-small" : "data-src");
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }


  function initFilmVideos() {
    $$("[data-film-video]").forEach(function (v) {
      if (reduceMotion || !("IntersectionObserver" in window)) return;
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          if (!v.src) v.src = v.getAttribute("data-src");
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      }, { threshold: 0.2 }).observe(v);
    });
  }

  /* Global events ------------------------------------------------- */

  function bind() {
    document.addEventListener("click", function (e) {
      var t = e.target.closest("[data-cart-open], [data-cart-close], [data-qty], [data-remove], [data-checkout], [data-checkout-express], [data-sheet], [data-sheet-close], .menu-toggle, .drawer [data-quick-add]");
      if (!t) return;

      if (t.matches("[data-cart-open]")) { e.preventDefault(); openCart(); }
      else if (t.matches("[data-cart-close]")) closeCart();
      else if (t.matches("[data-sheet]")) { e.preventDefault(); openSheet(t.getAttribute("data-sheet")); }
      else if (t.matches("[data-sheet-close]")) closeSheets();
      else if (t.matches(".menu-toggle")) toggleMenu();
      else if (t.matches("[data-quick-add]")) addToCart([t.getAttribute("data-quick-add")]);
      else if (t.matches("[data-qty]")) {
        var k = t.getAttribute("data-qty");
        var line = readCart().filter(function (l) { return lineKey(l) === k; })[0];
        if (line) setQty(k, line.qty + Number(t.getAttribute("data-delta")));
      }
      else if (t.matches("[data-remove]")) setQty(t.getAttribute("data-remove"), 0);
      else if (SHOP && t.matches("[data-checkout]")) {
        var code = cartCode(readCart());
        window.location.href = code ? "/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(SHOP.routes.checkout) : SHOP.routes.checkout;
      }
      else if (t.matches("[data-checkout-express]")) {
        var label = t.innerHTML;
        t.textContent = "Via Shopify";
        setTimeout(function () { t.innerHTML = label; }, 2200);
      }
      else if (t.matches("[data-checkout]")) {
        t.textContent = "Paiement géré par Shopify";
        setTimeout(function () { t.textContent = "Passer commande"; }, 2200);
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      if ($(".sheet.is-open")) closeSheets();
      else if (drawer.classList.contains("is-open")) closeCart();
      else if (document.documentElement.classList.contains("menu-open")) { closeMenu(); document.body.classList.remove("is-locked"); }
    });

    $$("[data-newsletter]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var input = $("input", form);
        if (!input.value || !input.checkValidity()) { input.focus(); return; }
        subscribe(input.value, "newsletter");
        form.innerHTML = '<p style="padding:12px 0">Merci, c’est noté.</p>';
      });
    });
  }

  /* Shopify customer form: creates the customer with e-mail marketing consent */
  function subscribe(email, tags) {
    if (!SHOP) return;
    var fd = new FormData();
    fd.append("form_type", "customer");
    fd.append("utf8", "\u2713");
    fd.append("contact[email]", email);
    fd.append("contact[tags]", tags);
    fetch(SHOP.routes.contact, { method: "POST", body: fd, credentials: "same-origin" }).catch(function () {});
  }

  /* Welcome pop-up ------------------------------------------------ */

  var WELCOME = { code: "BIENVENUE10", amount: "10\u00a0%", delay: 12000, scroll: 0.4, snoozeDays: 14 }; // remise de bienvenue, à créer aussi dans Shopify
  var WELCOME_KEY = "kiyohako-welcome";

  function initWelcome() {
    var el = $("[data-welcome]");
    if (!el || document.body.getAttribute("data-page") === "legal") return;
    // Kiyohako One page (where the ads land): no pop-up at all, the free mat is already shown in the buy box
    var isOne = document.body.getAttribute("data-page") === "product" &&
      (new URLSearchParams(window.location.search).get("handle") || document.body.getAttribute("data-handle") || "kiyohako-one") === "kiyohako-one";
    if (isOne || Date.now() <= OFFER_END) return; // no pop-up promising the free mat during the Halloween offer
    if (SHOP && SHOP.welcome) {
      if (!SHOP.welcome.enabled) return;
      WELCOME.code = SHOP.welcome.code || WELCOME.code;
      WELCOME.amount = SHOP.welcome.amount || WELCOME.amount;
    }
    var state = null;
    try { state = JSON.parse(localStorage.getItem(WELCOME_KEY) || "null"); } catch (e) {}
    if (state && (state.done || Date.now() - state.t < WELCOME.snoozeDays * 864e5)) return;
    $$("[data-welcome-amount]", el).forEach(function (s) { s.textContent = WELCOME.amount; });
    $("[data-welcome-code]", el).textContent = WELCOME.code;
    var shown = false, timer;
    function save(v) { try { localStorage.setItem(WELCOME_KEY, JSON.stringify(v)); } catch (e) {} }
    // Shopify's cookie banner still waiting for an answer: one overlay at a time on a first visit
    function consentPending() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      try { return !!(cp && cp.shouldShowBanner() && cp.currentVisitorConsent().marketing === ""); } catch (e) { return false; }
    }
    function busy() { return $(".sheet.is-open") || (drawer && drawer.classList.contains("is-open")) || document.documentElement.classList.contains("menu-open") || consentPending(); }
    function show() {
      if (shown) return;
      if (busy()) { clearTimeout(timer); timer = setTimeout(show, 4000); return; }
      shown = true; cleanup();
      el.classList.add("is-open"); el.setAttribute("aria-hidden", "false");
      setTimeout(function () { var i = $("input", el); if (i && window.matchMedia("(hover: hover)").matches) i.focus(); }, 300);
    }
    function close() {
      el.classList.remove("is-open"); el.setAttribute("aria-hidden", "true");
      if (!(state && state.done)) save({ t: Date.now() });
    }
    function onScroll() {
      var max = document.documentElement.scrollHeight - innerHeight;
      if (max > 0 && scrollY / max > WELCOME.scroll) show();
    }
    function onLeave(e) { if (e.clientY <= 0) show(); }
    function cleanup() { clearTimeout(timer); window.removeEventListener("scroll", onScroll); document.removeEventListener("mouseout", onLeave); }
    // Other product pages: no pop-up while the visitor reads, only after 40 s or when leaving (computer)
    var onProduct = document.body.getAttribute("data-page") === "product";
    timer = setTimeout(show, onProduct ? 40000 : WELCOME.delay);
    if (!onProduct) window.addEventListener("scroll", onScroll, { passive: true });
    if (window.matchMedia("(hover: hover)").matches) document.addEventListener("mouseout", onLeave);
    el.addEventListener("click", function (e) {
      if (e.target.closest("[data-welcome-close]")) close();
      var copy = e.target.closest("[data-welcome-copy]");
      if (copy) {
        try { navigator.clipboard.writeText($("span", copy).textContent); } catch (err) {}
        $("small", copy).textContent = "Copié";
      }
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && el.classList.contains("is-open")) close(); });
    $("[data-welcome-form]", el).addEventListener("submit", function (e) {
      e.preventDefault();
      var input = $("input", e.target);
      if (!input.value || !input.checkValidity()) { input.focus(); input.setAttribute("aria-invalid", "true"); return; }
      subscribe(input.value, "newsletter,bienvenue");
      state = { done: true, t: Date.now() }; save(state);
      $('[data-welcome-step="form"]', el).hidden = true;
      $('[data-welcome-step="done"]', el).hidden = false;
    });
  }

  /* Init ---------------------------------------------------------- */

  drawer = buildDrawer();
  initWelcome();
  bind();
  renderCart();
  expireOffers();
  initAnnounce();
  initFilmVideos();

  /* Mega menu ---------------------------------------------------- */

  function initMega() {
    var item = $("[data-mega]");
    var panel = $("[data-mega-panel]");
    var btn = $("[data-mega-toggle]");
    if (!item || !panel || !btn) return;
    var timer;
    function set(open) {
      clearTimeout(timer);
      document.documentElement.classList.toggle("mega-open", open);
      btn.setAttribute("aria-expanded", String(open));
    }
    function later(open, ms) { clearTimeout(timer); timer = setTimeout(function () { set(open); }, ms); }
    var hover = window.matchMedia("(hover: hover)").matches;
    if (hover) {
      [item, panel].forEach(function (el) {
        el.addEventListener("mouseenter", function () { later(true, 80); });
        el.addEventListener("mouseleave", function () { later(false, 160); });
      });
    }
    btn.addEventListener("click", function () { set(btn.getAttribute("aria-expanded") !== "true"); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") set(false); });
    document.addEventListener("click", function (e) { if (!e.target.closest("[data-mega], [data-mega-panel]")) set(false); });
    panel.addEventListener("focusout", function (e) { if (!panel.contains(e.relatedTarget) && e.relatedTarget !== btn) set(false); });
    window.addEventListener("scroll", function () { if (document.documentElement.classList.contains("subnav-stuck")) set(false); }, { passive: true });
  }
  initMega();

  /* Cookies page: reopens Shopify's consent banner preferences */
  $$("[data-cookie-prefs]").forEach(function (b) {
    b.addEventListener("click", function () {
      if (window.privacyBanner && window.privacyBanner.showPreferences) window.privacyBanner.showPreferences();
    });
  });

  var page = document.body.getAttribute("data-page");
  if (page === "home") { initHome(); initHeroVideo(); }
  if (page === "collection") initCollection();
  if (page === "product") initProduct();
})();
